import React from 'react'
import './Choose.css';
import { GiTrophyCup } from "react-icons/gi";
import { FaBoxArchive } from "react-icons/fa6";
import { GiMoebiusTriangle } from "react-icons/gi";
import { FiPlusSquare } from "react-icons/fi";

const Choose = () => {
  return (
    <>
    <div className='body15'>
      <div className="container15">
        <div className="contentLeft15">
            <div className="row15">
                <div className="imgWrapper15">
                    <img src="/images/24.jpg" alt="" />
                </div>
                <div className="imgWrapper15">
                    <img src="/images/25.jpg" alt="" />
                </div>
                <div className="imgWrapper15">
                    <img src="/images/26.jpg" alt="" />
                </div>
                <div className="imgWrapper15">
                    <img src="/images/22.jpg" alt="" />
                </div>
            </div>
        </div>
        <div className="contentRight30">
            <div className="content30">
                <h1>Why Choose</h1>
                <h2> Somnath polytex</h2>
                <hr  className='hr'/>
                <h3><GiTrophyCup /> Quality Assurance</h3>
                <h3><FaBoxArchive /> Different Varieties</h3>
                <h3><GiMoebiusTriangle /> Sustainability</h3>
                <h3><FiPlusSquare /> Reliability</h3>
                {/* <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nostrum laudantium nesciunt aliquam atque vitae ducimus, similique at repellat soluta dicta?</p>
                <a href="#">Read More</a> */}
            </div>
        </div>

      </div>
    </div>
    </>
  )
}

export default Choose
